import { lazy } from 'react';
import { DataRouteConfig } from '@commonPackage/types';
import {
  CenterRouteRootSlugEnum,
  CenterRouteWithAidSlugEnum,
  CenterRouteWithUserSlugEnum,
} from '@commonPackage/constants';
import { Layout } from '@/layout';
import { UserLayout } from '@/layout/UserLayout';

// 个人中心
const ChangePhone = lazy(() => import('@/pages/user/changePhone'));
const PersonalInfoPage = lazy(() => import('@/pages/user/personalInfo'));
const UserCenter = lazy(() => import('@/pages/user/userCenter'));

const Login = lazy(() => import('@/pages/login'));
// 注册
const Registration = lazy(() => import('@/pages/registration'));
const Success = lazy(() => import('@/pages/registration/Success'));
const Results = lazy(() => import('@/pages/registration/Results'));

// 强制绑定手机号
const BindMobile = lazy(() => import('@/pages/bindMobile'));

const CenterActivityLayout = lazy(() => import('@commonPackage/layout/CenterActivityLayout'));

const ROUTE_CONFIG: DataRouteConfig[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        path: CenterRouteRootSlugEnum.Login,
        element: <Login />,
      },
      {
        path: CenterRouteWithAidSlugEnum.ActivityBase,
        element: <CenterActivityLayout />,
        children: [
          {
            path: CenterRouteWithAidSlugEnum.Login,
            element: <Login />,
          },
          {
            path: CenterRouteWithAidSlugEnum.BindMobile,
            element: <BindMobile />,
          },
          {
            path: CenterRouteWithAidSlugEnum.Registration,
            children: [
              { index: true, element: <Registration /> },
              {
                path: CenterRouteWithAidSlugEnum.RegistrationSuccess,
                element: <Success />,
              },
              {
                path: CenterRouteWithAidSlugEnum.RegistrationResultsWithType,
                element: <Results />,
              },
            ],
          },
        ],
      },
      {
        path: CenterRouteWithUserSlugEnum.UserBase,
        element: <UserLayout />,
        children: [
          {
            index: true,
            element: <UserCenter />,
          },
          {
            path: CenterRouteWithUserSlugEnum.ChangePhone,
            element: <ChangePhone />,
          },
          {
            path: CenterRouteWithUserSlugEnum.Info,
            element: <PersonalInfoPage />,
          },
        ],
      },
      {
        path: CenterRouteRootSlugEnum.BindMobile,
        element: <BindMobile />,
      },
      {
        path: CenterRouteRootSlugEnum.Registration,
        children: [
          {
            index: true,
            element: <Registration />,
          },
          {
            path: CenterRouteRootSlugEnum.RegistrationSuccess,
            element: <Success />,
          },
          {
            path: CenterRouteRootSlugEnum.RegistrationResultsWithType,
            element: <Results />,
          },
        ],
      },
    ],
  },

  { path: '*', redirect: `/${CenterRouteWithUserSlugEnum.UserBase}` },
];

export default ROUTE_CONFIG;
